import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';

import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import reducers from './reducers';
import { syncHistoryWithStore } from 'react-router-redux';
import { browserHistory, Router, Route } from 'react-router';
import { Provider } from 'react-redux';

import Layout from './components/layout/MainLayout'
import MainPage from './pages/MainPage'
import ListPage from './pages/ListPage'

import './css/style.css';
import { SnackbarProvider } from 'notistack';



const store = createStore(reducers, composeWithDevTools(applyMiddleware(thunk)))
const history = syncHistoryWithStore(browserHistory, store);

ReactDOM.render(
    <Provider store={store}>
        <SnackbarProvider maxSnack={3}>
            <Router history={history}>
                <Route component={Layout}>
                        <Route path='/' component={MainPage} />
                        <Route path='/*/:id' component={ListPage} />
                </Route>
            </Router>
        </SnackbarProvider>
    </Provider>,
    document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js